import { render, staticRenderFns } from "./withdrawalRecord.vue?vue&type=template&id=a3a51470&scoped=true"
import script from "./withdrawalRecord.vue?vue&type=script&lang=js"
export * from "./withdrawalRecord.vue?vue&type=script&lang=js"
import style0 from "./withdrawalRecord.vue?vue&type=style&index=0&id=a3a51470&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a51470",
  null
  
)

export default component.exports